// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/readback-hearback.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/readback-hearback/readback-hearback.js';

mount([g0]);
